import ROLES from "./roles";
import SYSTEM_GROUPS from "./system_groups";

export const profileMenu = [
    {
        title: 'Labs',
        icon: "/assets/images/labs.png",
        requiredRoles: [ROLES.System_User],
        // requiredGroups: [SYSTEM_GROUPS.Employees],
        children: [
            {
                title: 'Labs',
                icon: "/assets/images/labs.png",
                parentTitle: 'Labs',
                url: '/admin/masters/labs',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
            {
                title: 'Categories',
                icon: "/assets/images/list.png",
                parentTitle: 'Labs',
                url: '/admin/masters/lab/category',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            }
        ]
    },

    {
        title: 'Sessions',
        icon: '/assets/images/session.png',
        requiredRoles: [ROLES.System_User],
        // requiredGroups: [SYSTEM_GROUPS.Employees],
        children: [
            {
                title: 'Active Sessions',
                icon: '/assets/images/active-session.png',
                parentTitle: 'Sessions',
                url:'/admin/masters/session/active',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
            {
                title: 'Rogue Sessions',
                icon: '/assets/images/rogue-session.png',
                parentTitle: 'Sessions',
                url:'/admin/masters/session/rogue',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],

            }
        ]
    },
    {
        title: 'Videos',
        icon: '/assets/images/video.png',
        requiredRoles: [ROLES.System_User],
        // requiredGroups: [SYSTEM_GROUPS.Employees],
        children: [
            {
                title: 'Video Category',
                icon: '/assets/images/video-category.png',
                url:'/admin/masters/video/category',
                parentTitle: 'Videos',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
            {
                title: 'Video Catalog',
                icon: '/assets/images/catalog.png',
                url:'/admin/masters/video/catalog',
                parentTitle: 'Videos',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            }
        ]
    },
    {
        title: 'Tools',
        icon: '/assets/images/tools.png',
        requiredRoles: [ROLES.System_User],
        // requiredGroups: [SYSTEM_GROUPS.Employees],
        children: [
            {
                title: 'Tools',
                icon: '/assets/images/tools.png',
                url:'/admin/masters/tools',
                parentTitle: 'Tools',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
            {
                title: 'Categories',
                icon: '/assets/images/list.png',
                url:'/admin/masters/tools/category',
                parentTitle: 'Tools',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
        ]
    },
    {
        title: 'Documents',
        icon: '/assets/images/catalog.png',
        requiredRoles: [ROLES.System_User],
        // requiredGroups: [SYSTEM_GROUPS.Employees],
        children: [
            {
                title: 'Documents',
                icon: '/assets/images/user-list.png',
                url:'/admin/masters/documents',
                parentTitle: 'Documents',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
            {
                title: 'Categories',
                icon: '/assets/images/list.png',
                url:'/admin/masters/documents/category',
                parentTitle: 'Documents',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
        ]
    },
    {
        title: 'Users',
        icon: '/assets/images/user.png',
        requiredRoles: [ROLES.System_User],
        // requiredGroups: [SYSTEM_GROUPS.Employees],
        children: [
            {
                title: 'Groups',
                icon: '/assets/images/group.png',
                parentTitle: 'Users',
                url: '/admin/masters/groups',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
            {
                title: 'Users List',
                icon: '/assets/images/user-list.png',
                parentTitle: 'Users',
                url: '/admin/masters/users',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
            },
        ]
    },
    {
        title: 'Admin Settings',
        icon: '/assets/images/admin.png',
        requiredRoles: [ROLES.System_User],
        // requiredGroups: [SYSTEM_GROUPS.Employees],
        children: [
            {
                title: 'Help',
                icon: '/assets/images/question.png',
                parentTitle: 'Admin Settings',
                requiredRoles: [ROLES.System_User],
                // requiredGroups: [SYSTEM_GROUPS.Employees],
                children: [
                    {
                        title: 'FAQ',
                        icon: '/assets/images/faq.png',
                        parentTitle: 'Help',
                        url: '/admin/masters/faq',
                        requiredRoles: [ROLES.System_User],
                        // requiredGroups: [SYSTEM_GROUPS.Employees],
                    },
                    {
                        title: 'Feedback',
                        icon: '/assets/images/rating.png',
                        parentTitle: 'Help',
                        url: '/admin/masters/feedback',
                        requiredRoles: [ROLES.System_User],
                        // requiredGroups: [SYSTEM_GROUPS.Employees],
                    },
                    {
                        title: 'Support',
                        icon: '/assets/images/support.png',
                        url: '/admin/masters/support',
                        parentTitle: 'Help',
                        requiredRoles: [ROLES.System_User],
                        // requiredGroups: [SYSTEM_GROUPS.Employees],
                    }
                ]
            },

            // Notification and Landing Page will be considered in MVP-2
            // {
            //     title: 'Notification',
            //     icon: '/assets/images/notification.png',
            //     parentTitle: 'Admin Settings',
            //     requiredRoles: [ROLES.System_User],
            //     requiredGroups: [SYSTEM_GROUPS.Employees],
            // },
            // {
            //     title: 'Landing Page',
            //     icon: '/assets/images/home.png',
            //     parentTitle: 'Admin Settings',
            //     requiredRoles: [ROLES.System_User],
            //     requiredGroups: [SYSTEM_GROUPS.Employees],
            // },
            // {
            //     title: 'Maintenance',
            //     icon: '/assets/images/maintenance.png',
            //     parentTitle: 'Admin Settings',
            //     requiredRoles: [ROLES.System_User],
            //     requiredGroups: [SYSTEM_GROUPS.Employees],
            // },
            {
                title: 'App Settings',
                icon: '/assets/images/setting.png',
                parentTitle: 'Admin Settings',
                url: '/admin/settings',
                requiredRoles: [ROLES.System_User],
            }
        ]
    },
    {
        title: 'Log Off',
        icon: '/assets/images/log-out.png',
        url: '/logout',
    }


]